import React, { useEffect, useState } from "react";
import axios from "axios";
import "./AdminProducts.css";

const API_BASE = process.env.REACT_APP_API_BASE ;

const AdminProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updatingQty, setUpdatingQty] = useState({});

  // FETCH PRODUCTS
  const fetchProducts = async () => {
    const token = localStorage.getItem("access");
    if (!token) {
      alert("Please login first");
      setLoading(false);
      return;
    }
    try {
      const res = await axios.get(`${API_BASE}/admin/products/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setProducts(res.data.results || res.data);
    } catch (err) {
      if (err.response?.status === 401) {
        localStorage.clear();
        window.location.href = "/admin/login";
      } else {
        alert("Failed to load products");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  // TOGGLE ACTIVE
  const toggleActive = async (id) => {
    const token = localStorage.getItem("access");
    if (!token) {
      alert("Please login first");
      return;
    }
    try {
      await axios.patch(
        `${API_BASE}/admin/products/${id}/toggle-active/`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setProducts((prev) =>
        prev.map((p) =>
          p.id === id ? { ...p, is_active: !p.is_active } : p
        )
      );
    } catch (err) {
      if (err.response?.status === 401) {
        localStorage.clear();
        window.location.href = "/admin/login";
      } else {
        alert("Toggle failed");
      }
    }
  };

  // QUANTITY +/- HANDLERS
  const updateQuantity = async (id, newQuantity) => {
    const token = localStorage.getItem("access");
    if (!token) {
      alert("Please login first");
      return;
    }
    setUpdatingQty((old) => ({ ...old, [id]: true }));
    try {
      await axios.patch(
        `${API_BASE}/api/v1/products/${id}/update-quantity/`,
        { quantity: newQuantity },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setProducts((prev) =>
        prev.map((p) =>
          p.id === id ? { ...p, quantity: newQuantity } : p
        )
      );
    } catch (err) {
      alert("Failed to update quantity");
    } finally {
      setUpdatingQty((old) => ({ ...old, [id]: false }));
    }
  };

  if (loading) return <p className="loading-text">Loading products...</p>;

  return (
    <div className="admin-products">
      <h2>Admin Products</h2>
      <div className="table-wrapper">
        <table className="products-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Price</th>
              <th>Quantity</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {products.map((p) => (
              <tr key={p.id}>
                <td>{p.id}</td>
                <td>{p.name}</td>
                <td>ETB {p.price}</td>
                <td>
                  <button
                    onClick={() => updateQuantity(p.id, Math.max(0, (p.quantity || 0) - 1))}
                    disabled={updatingQty[p.id] || (p.quantity || 0) === 0}
                    className="qty-btn"
                  >-</button>
                  <span className="qty-value">{p.quantity ?? 0}</span>
                  <button
                    onClick={() => updateQuantity(p.id, (p.quantity || 0) + 1)}
                    disabled={updatingQty[p.id]}
                    className="qty-btn"
                  >+</button>
                </td>
                <td>
                  <span className={p.is_active ? "status-active" : "status-inactive"}>
                    {p.is_active ? "Active" : "Inactive"}
                  </span>
                </td>
                <td>
                  <button
                    className={`toggle-btn ${p.is_active ? "active" : "inactive"}`}
                    onClick={() => toggleActive(p.id)}
                  >
                    {p.is_active ? "Deactivate" : "Activate"}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminProducts;